/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Reportproblem1Inputs */

const en_questionnaire_reportproblem1 = /** @type {(inputs: Questionnaire_Reportproblem1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a technical problem`)
};

const fr_questionnaire_reportproblem1 = /** @type {(inputs: Questionnaire_Reportproblem1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler un problème technique`)
};

/**
* | output |
* | --- |
* | "Report a technical problem" |
*
* @param {Questionnaire_Reportproblem1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_reportproblem1 = /** @type {((inputs?: Questionnaire_Reportproblem1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Reportproblem1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_reportproblem1(inputs)
	return fr_questionnaire_reportproblem1(inputs)
});
export { questionnaire_reportproblem1 as "questionnaire_reportProblem" }